import { Ability } from 'ember-can';

export default class RoomAbility extends Ability {
  get canVisit(): boolean {
    return false;
  }
}
